<template>
    <div class="app-inner" id="Order">
        <div class="p-tit-c">
            <div class="businessList-filter">
                 <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">订单编号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入订单编号" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                       <div class="fl-rt flex align-cen">
                    <div class="label">下单企业ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入下单企业ID" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                       <div class="fl-rt flex align-cen">
                    <div class="label">下单企业名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入下单企业名称" v-model="search2" clearable> </el-input>
                    </div>
                    </div>
                 </div>
                 <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                         <div class="label">订单状态：</div>
                           <el-radio-group v-model="radio" size="small" @change="classSelect">
                            <el-radio-button label=""  >全部({{orderNum.total}})</el-radio-button>
                            <el-radio-button :label="1"  >待付款 <span style="color:red">({{orderNum.payCount}})</span> </el-radio-button>
                            <el-radio-button :label="2"  >已完成<span style="color:red">({{orderNum.completeCount}})</span></el-radio-button>
                            <el-radio-button :label="0" >已取消<span style="color:red">({{orderNum.cancelCount}})</span></el-radio-button>
                            </el-radio-group>
                        </div>
                 </div>
                   <div class="businessList-filter-list flex align-cen">
                    <div class="label">支付方式：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                           @click="allradio('')"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio1" label="2"  @change="classSelect">微信</el-radio>
                        <el-radio v-model="radio1" label="1" @change="classSelect">支付宝</el-radio>
                        <el-radio v-model="radio1" label="3" @change="classSelect">对公转账</el-radio>
                 </div>
                   <div class="businessList-filter-list flex align-cen">
                    <div class="label">订单分类：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                           @click="allradio(3)"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio3" label="1"  @change="classSelect">应用订单</el-radio>
                        <el-radio v-model="radio3" label="2" @change="classSelect">课程订单</el-radio>
                 </div>
                 <div class="businessList-filter-list flex align-cen">
                    <div class="label">应用官网分类：</div>
                    <div
                      style="color: red; padding-right: 20px; cursor: pointer"
                      @click="allradio(2)"
                    >
                      不限
                    </div>
                    <el-radio v-model="radio2" label="1" @change="classSelect">和隆优化官网</el-radio>
                    <el-radio v-model="radio2" label="2" @change="classSelect">和隆软件官网</el-radio>
                  </div>
                    <div class="businessList-filter-list flex align-cen">
                     <div class="label">提交时间：</div>
                      <el-date-picker
                            v-model="value"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                             @change="classSelect"
                            >
                            </el-date-picker>
                  </div>
    <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
          搜索
        </div>
        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
            </div>
        </div>
         <div class="businessList-container">
            <div class="businessList-container-table">
                <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
           :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
        <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
               <el-table-column prop="id" label="订单编号" align="center" >
          </el-table-column>
           <el-table-column prop="createTime" label="提交时间" align="center"  width="200">
          </el-table-column>
                <el-table-column label="订单分类" align="center" prop="id" width="150">
          <template slot-scope="scope">
            <span>
             {{scope.row.orderType == 1 ? '应用订单' : scope.row.orderType == 2 ? '课程订单' : ''}}
            </span>
          </template>
         </el-table-column>
           <el-table-column prop="businessName" label="下单企业名称" align="center" >
          </el-table-column>
          <el-table-column prop="businessId" label="下单企业ID" align="center" >
          </el-table-column>
             <el-table-column label="应用官网分类" align="center" prop="id" width="200">
          <template slot-scope="scope">
            <span>
              {{$util.offType(scope.row.officialType)}}
            </span>
          </template>
         </el-table-column>
           <el-table-column  label="订单金额" align="center" >
            <template slot-scope="scope">
                ¥{{scope.row.orderAmount}}
            </template>
          </el-table-column>
            <el-table-column  label="实付款金额" align="center">
                <template slot-scope="scope">
                <p v-if="scope.row.orderStatus != 1">¥{{scope.row.payAmount}}</p>
                <p v-else>待支付</p>
            </template>
            </el-table-column>
           <el-table-column  label="支付方式" align="center" >
              <template slot-scope="scope">
                {{scope.row.payType == 1 ? '支付宝' : scope.row.payType == 2 ? '微信支付' : scope.row.payType == 3 ? '对公转账' : '未支付'}}
              </template>
           </el-table-column>
           <el-table-column  label="订单状态" align="center" >
            <template slot-scope="scope">
                {{scope.row.orderStatus == 0 ? '已取消' : scope.row.orderStatus == 1 ? '待支付' : '已完成'}}
            </template>
           </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            
            >
            <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看订单</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red" v-if="scope.row.orderStatus == 1" @click.stop="closeOrder(scope.row)">关闭订单</el-button>
            </template>
            </el-table-column>
       </el-table>
              <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
            </div>
         </div>
         <!-- 关闭订单弹窗 -->
         
    </div>
</template>
<script>
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
import { orderList,closeOrder,countOrder} from "@/api/index/index" // 订单列表、关闭订单、订单条数
export default {
    name:'order',
    data () {
        return {
          radio2:'',
              paid:0,
             totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            list:[],
            multipleSelection:[],
            search:'',
            search1:'',
            search2:'',
            radio:'',
            radio1:'',
            radio3:'',
            value:'',
             start_time:'',
            end_time:'',
            orderNum:{},
                    pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
        activated(){
  this.gethisInfo()
  this.getorderNum()
},
    created() {
        this.gethisInfo()
    },
    methods: {
      // 获取订单条数
      getorderNum(){
        countOrder()
        .then(res => {
         this.orderNum = res.data || {total:0,payCount:0,completeCount:0,cancelCount:0}
        })
      },
          //导出
      exportExcel(val){ 
             if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '订单编号':val[item].id, 
              '提交时间':val[item].createTime, 
              '下单企业名称':val[item].businessName,
              '下单企业ID':val[item].businessId,
              '订单金额':val[item].orderAmount,
              '支付方式':val[item].payType == 1 ? '支付宝' : val[item].payType == 2 ? '微信' : val[item].payType == 3 ? '对公转账' : '未支付',
              '订单状态':val[item].orderStatus == 0 ? '已取消' : val[item].orderStatus == 1 ? '待支付' : '已完成',
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
             }else{
                this.$message.error('未选择导出数据')
             }
        },
      // 订单列表查询
      gethisInfo(){
        let params = {
          id:this.search,
          businessId:this.search1,
          businessName:this.search2,
          orderStatus:this.radio,
          payType:this.radio1,
          createTimeStart:this.start_time,
          createTimeEnd:this.end_time,
          current: this.currentPage,
         size:this.PageSize,
         officialType:this.radio2,
         orderType:this.radio3
        }
        orderList(params)
        .then(res => {
          this.list = res.data.records
          this.totalCount = res.data.total;
        })
        .catch(err => {})
      },
        // 关闭订单
        closeOrder(e){
         this.$prompt('', '关闭订单', {
          inputPlaceholder:'操作备注【必填1-50字符】',
          inputType:'textarea',
          inputPattern:/^[0-9a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{1,50}$/,
          inputErrorMessage: '请输入1-50字符',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
            this.editbusiness(e,value)
        }).catch(() => {     
        });
        },
        editbusiness(e,value){
           closeOrder({id:e.id,remark:value,orderStatus:0})
        .then(res => {
          if(res.code == 0){
            this.$util.Notifi('关闭成功','success','fa-check');
            this.gethisInfo()
          }else{
            this.$util.Notifi('关闭失败','error','fa-exclamation-circle')
          }
        })
        .catch(err =>{
          this.$util.Notifi('关闭失败','error','fa-exclamation-circle')
        })
        },
        // 查看订单
        detail(e){
               this.$router.push({
            name: "orderDetail",
            query:{
                id:e.id,
            }
           })
        },
         allradio(type){
            this[`radio${type}`] = ""
            this.currentPage = 1
            this.gethisInfo()
        },
             // 筛选
        classSelect(){
            if(this.value){
             this.start_time = this.value[0]
            this.end_time = this.value[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        // 重置
        reset(){
              this.search = ""
          this.search1 = ""
          this.search2 = ""
           this.radio = "",
            this.radio1 = "",
            this.radio2 = "",
            this.radio3 = "",
           this.value = ""
           this.start_time=""
           this.end_time=""
           this.currentPage = 1
         this.gethisInfo()
        },
              handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
              getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    },
}
</script>
<style lang="scss" scoped>
::v-deep{
    .el-radio-button__orig-radio:checked + .el-radio-button__inner{
        background: #155bd4;
        border-color: #155bd4;
    }
}
</style>